<template>

	<!-- Page header -->
	<div class="page-header page-header-light shadow">
		<div class="page-header-content d-lg-flex">
			<div class="d-flex">
				<h4 class="page-title mb-0">
					<router-link href="#" class="mb-xs-1 text-dark cursor-pointer" :to="'Dashboard'"><i class="icon-arrow-left52 me-1"></i></router-link>
					<a href="#" class="hidden-xs text-dark fw-semibold cursor-pointer" v-on:click.prevent="getScadenze()"> Contabilità </a>
					<span class="hidden-xs ms-1">\</span>
					<span class="text-muted ms-1">Scadenzario</span>
				</h4>
			</div>
			<div class="d-lg-block my-lg-auto ms-lg-auto text-center">
				<div class="d-sm-flex align-items-center mb-3 mb-lg-0 ms-lg-3">
					<a href="#" class="d-inline-flex align-items-center text-body lh-1 py-sm-2" style="text-align: left;" v-if="$root.hasFunzionalita('SCADENZARI_CREATE')" v-on:click.prevent="nuovaScadenza()">
						<i class="ph-plus fw-bold me-2 btn btn-outline-success w-32px h-32px rounded-pill"></i>
						<div class="me-auto me-lg-1 ms-1">
							<div class="fs-sm text-muted mb-0">Nuova Scadenza</div>
							<div class="text-success fw-semibold"><Translate :path="'dizionario.base.BTN_ADD'"></Translate></div>
						</div>
					</a>
				</div>
			</div>
		</div>

		<div class="navbar navbar-expand-lg border-top py-1">
			<div class="container-fluid">
				<ul class="nav navbar-nav flex-row flex-fill">
					<li class="nav-item me-1">
						<a href="#" class="navbar-nav-link navbar-nav-link-icon navbar-sm rounded active" @click.prevent>
							<div class="d-flex align-items-center mx-lg-1"><i class="ph-calendar-check"></i><span class="ms-1">Scadenze</span></div>
						</a>
					</li>
				</ul>
				<ul class="navbar-nav ms-lg-auto mt-2 mt-lg-0 select-small">
					<li class="nav-item dropdown ms-lg-1">
						<div class="btn-group">
							<a href="#" class="btn btn-flat-indigo border-transparent btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
								<i class="ph-gear me-1"></i><span style="font-size:0.8rem;"><Translate :path="'dizionario.base.AZIONI_MULTIPLE'"></Translate></span>
							</a>
							<div class="dropdown-menu dropdown-menu-end">
								<div class="dropdown-submenu dropdown-submenu-start" v-if="$root.hasFunzionalita('SCADENZARI_EXPORT')">
									<a href="#" class="dropdown-item"><i class="far fa-file-export fa-fw me-2"></i><span class="text-muted me-1">|</span>Esporta dati</a>
									<div class="dropdown-menu">
										<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('pagina')"><i class="far fa-file-export fa-fw me-2"></i>Pagina corrente</a>
										<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('selezionati')"><i class="far fa-file-export fa-fw me-2"></i>Scadenze selezionate</a>
										<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('tutti')"><i class="far fa-file-export fa-fw me-2"></i>Tutte le scadenze</a>
									</div>
								</div>
								<div class="dropdown-divider"></div>
								<a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('SCADENZARI_DELETE')" @click.prevent="eliminaSelezionati()">
									<i class="far fa-trash fa-fw me-2 text-danger"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.ELIMINA_SELEZIONATI'"></Translate>
								</a>
								<a href="#" class="dropdown-item" v-if="$root.isGod && arrayScadenze.some(s => s.SELEZIONATO == 1 && s.FLG_ELIMINATO == 1)" @click.prevent="ripristinaSelezionati()">
									<i class="fad fa-redo fa-fw me-2 text-success"></i><span class="text-muted me-1">|</span>Ripristina selezionati
								</a>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
	<!-- /page header -->

	<div class="content content-1 table-cms-wrapper">

		<div class="row g-2 mb-2">
			<div class="col-6 col-xl-3" v-for="k in kpi" :key="k.label">
				<KpiCard :label="k.label" :icona="k.icona" :tema="k.tema" :indicatore="{ valore: k.valore, unita: 'EUR' }" :nota="k.nota" />
			</div>
		</div>

		<div class="card shadow mb-xs-3 mb-lg-0">
			<div class="card-body pb-0">
				<div class="alert alert-2 alert-secondary border-0">
					<div class="row g-2 align-items-center">
						<div class="col-6 col-md-1">
							<select class="form-select form-select-sm" v-model="anno" @change="getScadenze()">
								<option value="0">Anno</option>
								<option v-for="a in anni" :key="a" :value="a">{{ a }}</option>
							</select>
						</div>
						<div class="col-6 col-md-2">
							<select class="form-select form-select-sm" v-model="search.STATO.VALUE">
								<option v-for="s in stati" :key="s.valore" :value="s.valore">{{ s.label }}</option>
							</select>
						</div>
						<div class="col-12 col-md-3">
							<SelectIntestatario v-model:pg="filtroPg" v-model:pf="filtroPf" :placeholder="'Tutti'" @change="getScadenze()"></SelectIntestatario>
						</div>
						<div class="col-6 col-md-2">
							<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Cerca descrizione" v-model="search.DESCRIZIONE.VALUE" />
						</div>
						<div class="col-5 col-md-1">
							<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="N. fattura" v-model="search.NUMERO.VALUE" />
						</div>
						<div class="col-1 col-xl-auto ps-0" v-if="$root.isGod">
							<a href="#collapse-scadenzario" class="btn btn-flat-info btn-sm w-100 collapsed" data-bs-toggle="collapse" @click.prevent="filters.resizeGrid('collapse-scadenzario','tableFixHead','box-card')" role="button" aria-expanded="false">S</a>
						</div>
					</div>
					<div class="collapse" id="collapse-scadenzario" v-if="$root.isGod">
						<div class="row">
							<div class="col-12 col-md-2 mt-1">
								<select class="form-select form-select-sm" v-model="eliminati" @change="getScadenze()">
									<option value="0">Non eliminate</option>
									<option value="2">Tutte</option>
									<option value="1">Eliminate</option>
								</select>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="card-body box-card mt-0 mb-0" id="box-card">
				<div class="div_table_resp tableFixHead" id="tableFixHead">
					<table class="table table-bordered table-hover table-striped text-nowrap align-middle">
						<thead class="sticky-top">
							<tr class="bg-secondary text-white">
								<th class="table-head-sm text-center" style="width: 2%;"><input id="chkAllScadenze" type="checkbox" v-on:click="filters.selectAll('chkAllScadenze', paginatedList.arr)"></th>
								<th class="table-head-sm text-center" style="width: 4%;">#</th>
								<th class="table-head-sm text-center" style="width: 8%;">Scadenza</th>
								<th class="table-head-sm" style="width: 17%;">Intestatario</th>
								<th class="table-head-sm">Descrizione</th>
								<th class="table-head-sm" style="width: 13%;">Fattura</th>
								<th class="table-head-sm text-end" style="width: 9%;">Importo</th>
								<th class="table-head-sm text-center" style="width: 8%;">Stato</th>
								<th class="table-head-sm" style="width: 13%;">Pagamento</th>
								<th class="table-head-sm text-center" style="width: 5%;"><Translate :path="'dizionario.base.AZIONI'"></Translate></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="s in paginatedList.arr" :key="s.ID_SCADENZA" :class="{ 'table-danger text-muted': s.FLG_ELIMINATO == 1 }">
								<td class="td-class text-center"><input type="checkbox" v-bind:true-value="1" v-bind:false-value="0" v-model="s.SELEZIONATO"></td>
								<td class="td-class text-center fs-sm">{{ s.ID_SCADENZA }}</td>
								<td class="td-class text-center fs-sm">{{ s.DATA_SCADENZA_IT }}</td>
								<td class="td-class fs-sm" style="max-width: 0;">
									<div class="d-flex align-items-center" v-if="s.INTESTATARIO"><TestoEspandibile :testo="s.INTESTATARIO" icona="ph-user" /><span class="badge bg-light text-muted ms-1 flex-shrink-0">{{ s.TIPO_INTESTATARIO }}</span></div>
								</td>
								<td class="td-class fs-sm" style="max-width: 0;">
									<div class="d-flex align-items-center">
										<TestoEspandibile :testo="s.DESCRIZIONE" />
										<span v-if="s.FATTURA_ATTIVA == 0" class="badge bg-secondary ms-1 flex-shrink-0">Non attiva</span>
										<span v-if="s.FLG_ELIMINATO == 1" class="badge bg-danger ms-1 flex-shrink-0">Eliminata</span>
									</div>
								</td>
								<td class="td-class fs-sm"><template v-if="s.FK_ID_FATTURA > 0"><router-link v-if="$root.hasFunzionalita('FATTURAZIONE_READ')" :to="{ path: '/Invoice', query: { NUMERO: s.NUMERO, ANNO: s.DATA_FATTURA_IT.substr(6, 4) } }" title="Apri la fattura">n. {{ s.NUMERO }}</router-link><template v-else>n. {{ s.NUMERO }}</template> <small class="text-muted">del {{ s.DATA_FATTURA_IT }}</small></template></td>
								<td class="td-class fs-sm text-end fw-semibold">&euro; {{ filters.formattaImporto(s.IMPORTO) }}</td>
								<td class="td-class text-center">
									<span class="badge" :class="{ 'bg-success': s.STATO == 1, 'bg-danger': s.STATO == 2, 'bg-warning text-dark': s.STATO == 0 }">{{ ['Da pagare', 'Pagata', 'Scaduta'][s.STATO] }}</span>
								</td>
								<td class="td-class fs-sm">{{ s.STATO == 1 ? s.DATA_PAGAMENTO_IT + ' · ' + s.CONTO : '' }}</td>
								<td class="td-class text-center">
									<div class="dropdown">
										<a href="#" class="text-body" data-bs-toggle="dropdown" aria-expanded="false"><i class="ph-list"></i></a>
										<div class="dropdown-menu dropdown-menu-end">
											<template v-if="s.FLG_ELIMINATO != 1">
												<a href="#" class="dropdown-item" v-if="s.STATO != 1" @click.prevent="modificaScadenza(s)"><i class="fad fa-pencil fa-lg fa-fw me-2"></i><span class="text-muted me-1">|</span>Modifica</a>
												<a href="#" class="dropdown-item" v-if="s.STATO != 1 && $root.hasFunzionalita('SCADENZARI_CREATE')" @click.prevent="apriPagamento(s)"><i class="fad fa-money-bill fa-lg fa-fw me-2 text-success"></i><span class="text-muted me-1">|</span>Segna come pagata</a>
												<a href="#" class="dropdown-item" v-if="s.STATO == 1 && $root.hasFunzionalita('PRIMA_NOTA_DELETE')" @click.prevent="annullaPagamento(s)"><i class="fad fa-undo fa-lg fa-fw me-2 text-warning"></i><span class="text-muted me-1">|</span>Annulla pagamento</a>
												<a href="#" class="dropdown-item" v-if="s.STATO != 1 && $root.hasFunzionalita('SCADENZARI_DELETE')" @click.prevent="eliminaScadenza(s)"><i class="fad fa-trash fa-lg fa-fw me-2 text-danger"></i><span class="text-muted me-1">|</span>Elimina</a>
											</template>
											<a href="#" class="dropdown-item text-success" v-if="$root.isGod && s.FLG_ELIMINATO == 1" @click.prevent="ripristina([s])"><i class="fad fa-redo fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_RIPRISTINA'"></Translate></a>
										</div>
									</div>
								</td>
							</tr>
							<tr v-if="paginatedList.count == 0">
								<td colspan="10" class="text-center text-muted py-4">
									<i class="ph-calendar-blank d-block mb-2" style="font-size: 2.5rem;"></i>
									Nessuna scadenza
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="row page-bottom">
					<div class="col-12 col-md-5 d-none d-sm-block">
						<div style="position: relative; top: 10px;">
							<span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2">SCADENZE: {{ paginatedList.count }}</span>
						</div>
					</div>
					<div class="col-9 col-md-6">
						<div class="float-end pag-mobile">
							<Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count" :numpagine="search.PAGINATION.LENGTH" :modalita="$root.isMobile ? 2 : 1"></Pagine>
						</div>
					</div>
					<div class="col-3 col-md-1">
						<select class="form-select form-select-sm wmin-100 mt-2 float-end" v-model="search.PAGINATION.PAGE_SIZE">
							<option value="25">25</option>
							<option value="50">50</option>
							<option value="100">100</option>
						</select>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- MODALE SCADENZA -->
	<div class="modal fade" id="popUpScadenza" role="dialog" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h6 class="modal-title">{{ scadenza.ID_SCADENZA > 0 ? 'Scadenza n. ' + scadenza.ID_SCADENZA : 'Nuova scadenza' }}</h6>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					<div v-if="scadenza.FK_ID_FATTURA > 0" class="alert alert-info p-2 fs-sm"><i class="ph-info me-1"></i>Scadenza della fattura n. {{ scadenza.NUMERO }} del {{ scadenza.DATA_FATTURA_IT }}: l'intestatario è quello della fattura.</div>
					<div class="row">
						<div class="col-12 mb-2">
							<label class="form-label">Intestatario</label>
							<SelectIntestatario v-model:pg="scadenza.FK_ID_PERSONA_GIURIDICA" v-model:pf="scadenza.FK_ID_PERSONA_FISICA" :disabled="scadenza.FK_ID_FATTURA > 0"></SelectIntestatario>
						</div>
						<div class="col-12 mb-2">
							<label class="form-label">Descrizione {{ scadenza.FK_ID_FATTURA > 0 ? '' : '*' }}</label>
							<input type="text" class="form-control form-control-sm" v-model="scadenza.DESCRIZIONE" autocomplete="off" placeholder="Es. affitto ufficio novembre">
						</div>
						<div class="col-6 mb-2">
							<label class="form-label">Scadenza *</label>
							<Datepicker v-model="scadenza.DATA_SCADENZA" :formats="{ input: 'dd/MM/yyyy' }" auto-apply :enable-time-picker="false" :clearable="false" />
						</div>
						<div class="col-6 mb-2">
							<label class="form-label">Importo *</label>
							<input type="text" inputmode="decimal" class="form-control form-control-sm text-end" placeholder="0,00" v-model="scadenza.IMPORTO" @blur="normalizza(scadenza, 'IMPORTO')">
						</div>
						<div class="col-12 mb-2">
							<label class="form-label">Note</label>
							<input type="text" class="form-control form-control-sm" v-model="scadenza.NOTE" autocomplete="off">
						</div>
					</div>
				</div>
				<div class="modal-footer bg-light p-2">
					<button type="button" class="btn btn-link" data-bs-dismiss="modal"><i class="ph-x me-1"></i>Annulla</button>
					<template v-if="$root.hasFunzionalita(scadenza.ID_SCADENZA > 0 ? 'SCADENZARI_UPDATE' : 'SCADENZARI_CREATE')">
						<button type="button" class="btn btn-sm btn-secondary" @click="salvaScadenza(false)"><i class="ph-check me-1"></i>Salva e chiudi</button>
						<button type="button" class="btn btn-sm btn-primary" v-if="scadenza.ID_SCADENZA == 0" @click="salvaScadenza(true)"><i class="ph-check me-1"></i>Salva e continua</button>
					</template>
				</div>
			</div>
		</div>
	</div>

	<!-- MODALE PAGAMENTO -->
	<div class="modal fade" id="popUpPagamentoScadenza" role="dialog" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h6 class="modal-title">Pagamento scadenza n. {{ pagamento.ID_SCADENZA }}</h6>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					<p class="fs-sm text-muted mb-3">In Prima Nota verrà registrata un'uscita di <strong>&euro; {{ filters.formattaImporto(pagamento.IMPORTO) }}</strong>{{ pagamento.INTESTATARIO ? ' verso ' + pagamento.INTESTATARIO : '' }}.</p>
					<div class="row">
						<div class="col-6 mb-2">
							<label class="form-label">Data pagamento *</label>
							<Datepicker v-model="pagamento.DATA_MOVIMENTO" :formats="{ input: 'dd/MM/yyyy' }" auto-apply :enable-time-picker="false" :clearable="false" />
						</div>
						<div class="col-6 mb-2">
							<label class="form-label">Pagamento *</label>
							<SelectConto v-model="pagamento.FK_ID_CONTO"></SelectConto>
						</div>
						<div class="col-12 mb-2">
							<label class="form-label">Descrizione</label>
							<input type="text" class="form-control form-control-sm" v-model="pagamento.DESCRIZIONE" autocomplete="off">
						</div>
					</div>
				</div>
				<div class="modal-footer bg-light">
					<button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">CHIUDI</button>
					<button type="button" class="btn btn-success btn-sm" @click="paga()">REGISTRA PAGAMENTO</button>
				</div>
			</div>
		</div>
	</div>

	<PopUpEsportazione id="popUpEsportazioneScadenze" @esporta="esportaDati" />

</template>

<script>

import Pagine from '@/components/utils/Pagine.vue'
import SelectIntestatario from '@/components/common/SelectIntestatario.vue'
import SelectConto from '@/components/common/SelectConto.vue'
import KpiCard from '@/components/dashboard/KpiCard.vue'
import PopUpEsportazione from '@/components/common/PopUpEsportazione.vue'
import TestoEspandibile from '@/components/common/TestoEspandibile.vue'
import { VueDatePicker as Datepicker } from '@vuepic/vue-datepicker'

export default {
	name: "Scadenzari",

	components: { Pagine, SelectIntestatario, SelectConto, KpiCard, PopUpEsportazione, TestoEspandibile, Datepicker },

	data: function () {
		return {
			filters: global.filters,
			stati: [{ valore: '', label: 'Tutte' }, { valore: '2', label: 'Scadute' }, { valore: '0', label: 'Da pagare' }, { valore: '1', label: 'Pagate' }],
			anno: 0,
			filtroPg: 0,
			filtroPf: 0,
			eliminati: 0,
			arrayScadenze: [],
			scadenza: {},
			pagamento: {},
			esportazioneTipo: '',
			search: {
				PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 25 },
				STATO: { TYPE: 'COMBO', VALUE: '' },
				DESCRIZIONE: { TYPE: 'TEXT', VALUE: '' },
				NUMERO: { TYPE: 'TEXT', VALUE: '' },
			},
		}
	},

	computed: {
		anni() {
			const oggi = new Date().getFullYear();
			return Array.from({ length: 6 }, (x, i) => oggi + 1 - i);
		},
		paginatedList() {
			return utils.inGrid(this.arrayScadenze, this.search);
		},
		kpi() {
			const attive = this.arrayScadenze.filter(s => s.FLG_ELIMINATO != 1 && s.FATTURA_ATTIVA != 0);
			const fra30 = this.filters.formatDateOnly(new Date(Date.now() + 30 * 86400000));
			const gruppo = (f) => { const a = attive.filter(f); return { tot: utils.array.sumByField(a, 'IMPORTO'), n: a.length }; };
			const scadute = gruppo(s => s.STATO == 2), daPagare = gruppo(s => s.STATO != 1);
			const prossime = gruppo(s => s.STATO == 0 && s.DATA_SCADENZA <= fra30), pagate = gruppo(s => s.STATO == 1);
			return [
				{ label: 'Da pagare', valore: daPagare.tot, tema: 'blue', icona: 'ph-hourglass', nota: daPagare.n + ' scadenze aperte' },
				{ label: 'Scadute', valore: scadute.tot, tema: 'red', icona: 'ph-warning-circle', nota: scadute.n + ' scadenze oltre la data' },
				{ label: 'Prossimi 30 giorni', valore: prossime.tot, tema: 'purple', icona: 'ph-calendar', nota: prossime.n + ' scadenze in arrivo' },
				{ label: 'Pagate', valore: pagate.tot, tema: 'green', icona: 'ph-check-circle', nota: pagate.n + ' scadenze saldate' },
			];
		},
	},

	methods: {
		getScadenze() {
			utils.ajax('shared/scadenzari/lista', { ANNO: this.anno, FK_ID_PERSONA_GIURIDICA: this.filtroPg || 0, FK_ID_PERSONA_FISICA: this.filtroPf || 0, ELIMINATI: this.eliminati }, (response) => {
				this.arrayScadenze = response.data;
			}, true, 0, 'GET');
		},

		nuovaScadenza() {
			this.scadenza = this.scadenzaVuota();
			this.filters.openPopUp('popUpScadenza');
		},

		scadenzaVuota() {
			return { ID_SCADENZA: 0, FK_ID_FATTURA: 0, FK_ID_PERSONA_GIURIDICA: this.filtroPg || 0, FK_ID_PERSONA_FISICA: this.filtroPf || 0, DESCRIZIONE: '', DATA_SCADENZA: new Date(), IMPORTO: '', NOTE: '' };
		},

		modificaScadenza(s) {
			this.scadenza = utils.clone(s);
			this.scadenza.DATA_SCADENZA = new Date(s.DATA_SCADENZA);
			this.normalizza(this.scadenza, 'IMPORTO');
			this.filters.openPopUp('popUpScadenza');
		},

		salvaScadenza(continua = false) {
			const s = this.scadenza;
			const params = { ID_SCADENZA: s.ID_SCADENZA, FK_ID_FATTURA: s.FK_ID_FATTURA, FK_ID_PERSONA_GIURIDICA: s.FK_ID_PERSONA_GIURIDICA || 0, FK_ID_PERSONA_FISICA: s.FK_ID_PERSONA_FISICA || 0, DESCRIZIONE: s.DESCRIZIONE, DATA_SCADENZA: this.filters.formatDateOnly(s.DATA_SCADENZA), IMPORTO: this.filters.parseImporto(s.IMPORTO), NOTE: s.NOTE };
			const nuova = !(params.ID_SCADENZA > 0);
			utils.ajax(nuova ? 'shared/scadenzari/insert' : 'shared/scadenzari/update', params, (response) => {
				utils.alert.success(response.messaggio);
				if (continua) {
					this.scadenza = this.scadenzaVuota();
				} else {
					this.filters.closePopUp('popUpScadenza');
				}
				this.getScadenze();
			}, true, 0, nuova ? 'POST' : 'PUT');
		},

		apriPagamento(s) {
			this.pagamento = { ID_SCADENZA: s.ID_SCADENZA, IMPORTO: s.IMPORTO, INTESTATARIO: s.INTESTATARIO, DATA_MOVIMENTO: new Date(), FK_ID_CONTO: '', DESCRIZIONE: s.DESCRIZIONE || (s.FK_ID_FATTURA > 0 ? 'Scadenza fattura n. ' + s.NUMERO : '') };
			this.filters.openPopUp('popUpPagamentoScadenza');
		},

		paga() {
			const params = { IDS: [this.pagamento.ID_SCADENZA], DATA_MOVIMENTO: this.filters.formatDateOnly(this.pagamento.DATA_MOVIMENTO), FK_ID_CONTO: this.pagamento.FK_ID_CONTO, DESCRIZIONE: this.pagamento.DESCRIZIONE };
			utils.ajax('shared/scadenzari/paga', params, (response) => {
				utils.alert.success(response.messaggio);
				this.filters.closePopUp('popUpPagamentoScadenza');
				this.getScadenze();
			}, true, 0, 'POST');
		},

		// Il pagamento è un movimento di Prima Nota: annullarlo rimette da pagare tutte le scadenze che copriva
		annullaPagamento(s) {
			utils.alert.confirm('Annullare il pagamento del ' + s.DATA_PAGAMENTO_IT + '? Il movimento verrà eliminato dalla Prima Nota.', () => {
				utils.ajax('shared/prima_nota/delete', { ID_MOVIMENTO: s.FK_ID_MOVIMENTO }, (response) => {
					utils.alert.success(response.messaggio);
					this.getScadenze();
				}, true, 0, 'DELETE');
			}, this.$root);
		},

		eliminaScadenza(s) {
			this.elimina([s]);
		},

		eliminaSelezionati() {
			this.elimina(this.arrayScadenze.filter(s => s.SELEZIONATO == 1 && s.FLG_ELIMINATO != 1));
		},

		elimina(righe) {
			if (righe.length == 0) { utils.alert.warning('Nessuna scadenza selezionata.'); return; }
			utils.alert.confirm(righe.length == 1 ? 'Eliminare la scadenza n. ' + righe[0].ID_SCADENZA + '?' : 'Eliminare ' + righe.length + ' scadenze?', () => {
				utils.ajax('shared/scadenzari/delete', { IDS: righe.map(s => s.ID_SCADENZA) }, (response) => {
					utils.alert.success(response.messaggio);
					this.getScadenze();
				}, true, 0, 'DELETE');
			}, this.$root);
		},

		ripristinaSelezionati() {
			this.ripristina(this.arrayScadenze.filter(s => s.SELEZIONATO == 1 && s.FLG_ELIMINATO == 1));
		},

		ripristina(righe) {
			utils.alert.confirm(righe.length == 1 ? 'Ripristinare la scadenza n. ' + righe[0].ID_SCADENZA + '?' : 'Ripristinare ' + righe.length + ' scadenze?', () => {
				utils.ajax('shared/scadenzari/ripristina', { IDS: righe.map(s => s.ID_SCADENZA) }, (response) => {
					utils.alert.success(response.messaggio);
					this.getScadenze();
				}, true, 0, 'PUT');
			}, this.$root);
		},

		apriEsportazione(tipo) {
			this.esportazioneTipo = tipo;
			this.filters.openPopUp('popUpEsportazioneScadenze');
		},

		esportaDati(formato) {
			utils.esportaTabella({ tipo: this.esportazioneTipo, formato: formato, arrayCompleto: this.arrayScadenze, arrayPagina: this.paginatedList.arr, idField: 'ID_SCADENZA', modulo: 'scadenzario' });
		},

		normalizza(obj, campo) {
			obj[campo] = this.filters.formattaImporto(this.filters.parseImporto(obj[campo]));
		},
	},

	created: function () {
		this.getScadenze();
	},
}
</script>
